import React from 'react';
import { Box } from '@chakra-ui/react';

import { useImaginationRoom } from '@invitato/imagination-room';
import {
  BG_COVER_SLIDESHOW_1,
  BG_COVER_SLIDESHOW_2,
  // BG_COVER_SLIDESHOW_3,
  BG_COVER_SLIDESHOW_4,
  BG_COVER_SLIDESHOW_5,
} from '@/constants/assets';

import './styles.css';

function ImagesFade() {
  const { onGetFinalContent } = useImaginationRoom();
  return (
    <div className="slide">
      <Box
        background={`linear-gradient(rgb(50 48 48/ 50%), rgb(50 48 48 / 50%)),url(${onGetFinalContent(
          'BG_COVER_SLIDESHOW_1',
          BG_COVER_SLIDESHOW_1,
        )})`}
      />
      <Box
        background={`linear-gradient(rgb(50 48 48/ 50%), rgb(50 48 48 / 50%)), url(${onGetFinalContent(
          'BG_COVER_SLIDESHOW_2',
          BG_COVER_SLIDESHOW_2,
        )})`}
      />
      {/* <Box
        background={`linear-gradient(rgb(50 48 48/ 50%), rgb(50 48 48 / 50%)),url(${onGetFinalContent(
          'BG_COVER_SLIDESHOW_3',
          BG_COVER_SLIDESHOW_3,
        )})`}
      /> */}
      <Box
        background={`linear-gradient(rgb(50 48 48/ 50%), rgb(50 48 48 / 50%)),url(${onGetFinalContent(
          'BG_COVER_SLIDESHOW_4',
          BG_COVER_SLIDESHOW_4,
        )})`}
      />
      <Box
        background={`linear-gradient(rgb(50 48 48/ 50%), rgb(50 48 48 / 50%)),url(${onGetFinalContent(
          'BG_COVER_SLIDESHOW_5',
          BG_COVER_SLIDESHOW_5,
        )})`}
      />
    </div>
  );
}

export default ImagesFade;
